import { render } from "./CoachView.vue?vue&type=template&id=3cd1a56e&ts=true"
import script from "./CoachView.vue?vue&type=script&lang=ts"
export * from "./CoachView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/tomasfic/Projects/osobni/kometa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__